import React, { Component } from "react";
import '../css/albumorder.css'
import ReactModal from "react-modal";

class AlbumPhotoItem extends Component {
  constructor() {
    super();
    this.state = { showModal: false };
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  render() {
    const { photo, index, isCover } = this.props;
    const { showModal } = this.state;

  return (
    <>
      <ShowThumbnail
        showModal={showModal}
        handleCloseModal={this.handleCloseModal}
        photoUrl={photo.photo_url}
      />

      <div
        onClick={this.handleOpenModal}
        className="photo-item"
        style={{ cursor: "pointer" }}
      >
        <img
          src={photo.photo_url}
          alt={isCover ? "Cover" : `Page ${index + 1}`}
          className="photo-img"
          style={{
            display: "block",
            width: "100%",
            height: "auto",
            borderRadius: 8,
            objectFit: "cover",
          }}
        />
        <div
          className="photo-caption"
          style={{ textAlign: "center", marginTop: 6, fontSize: 12 }}
        >
          {isCover ? "Cover" : `Page ${index + 1}`}
        </div>
      </div>
    </>
  );
    }
}

class ShowThumbnail extends Component {
  render() {
    const { showModal, handleCloseModal, photoUrl } = this.props;

    return (
      <ReactModal
        ariaHideApp={false}
        isOpen={showModal}
        onRequestClose={handleCloseModal}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        className="album-modal-content"
        overlayClassName="album-modal-overlay"
        closeTimeoutMS={120}
      >
        <button className="album-modal-close-btn" onClick={handleCloseModal}>
          Close
        </button>
        <img src={photoUrl} alt="Album photo" className="album-modal-image" />
      </ReactModal>
    );
  }
}

export default AlbumPhotoItem